import { BUSINESS_TYPES } from '../supabaseClient';
import { matchPath } from 'react-router-dom';

// All business types get the same routes - truly agnostic across industries
const COMMON_ROUTES = [
  '/',
  '/home',
  '/activity',
  '/monitor/calls/:id',
  '/monitor/texts/:id',
  '/monitor/chats/:id',
  '/monitor/analysis',
  '/train/brainv2',
  '/train/suggestions',
  '/train/places',
  '/connect/apps',
  '/connect/apps/:providerSlug',
  '/connect/apps/curbside',
  '/connect/setup',
  '/connect/alerts',
  '/reports/insights',
  '/account/general',
  '/account/payment',
  '/account/billing',
  '/questions/:suggestionId',
  '/internal',
  '/admin/integrations',
  '/help',
  '/help/collections/:collectionSlug',
  '/help/articles/:articleSlug',
];

export const ROUTE_ACCESS = {
  [BUSINESS_TYPES.CLEANING]: COMMON_ROUTES,
  [BUSINESS_TYPES.LAUNDROMAT]: [
    ...COMMON_ROUTES,
    '/onboarding/business',
    '/admin/knowledge',
  ],
  [BUSINESS_TYPES.SHORT_TERM_RENTALS]: COMMON_ROUTES,
  [BUSINESS_TYPES.SELF_STORAGE]: COMMON_ROUTES,
  [BUSINESS_TYPES.PROPERTY_MANAGERS]: [
    ...COMMON_ROUTES,
    '/property-management/tour-times',
  ],
};

// Helper function to check if a route is accessible
export const isRouteAccessible = (businessType, pathname) => {
  // Always allow access to the landing page
  if (pathname === '/') return true;

  if (!businessType || !pathname) return false;

  const allowedRoutes = ROUTE_ACCESS[businessType] || COMMON_ROUTES;

  return allowedRoutes.some((route) => {
    // Create a match pattern object
    const pattern = {
      path: route,
      caseSensitive: false,
      end: true
    };

    // Use matchPath with proper parameters
    return matchPath(pattern, pathname);
  });
};